<template>
  <main class="main" role="main">
    <div class="main_con">
      <div ref="dummy"></div>
      <div class="card_list">
        <newsCard
          v-for="article in list"
          :key="article.id"
          :article="article"
          :newsType="boardId"
        />
      </div>
      <infinite-loading
        ref="infiniteLoading"
        :direction="direction"
        :identifier="infiniteId"
        @infinite="infiniteHandler"
      >
        <span slot="no-more"></span>
        <span slot="no-results"></span>
        <span slot="spinner"></span>
      </infinite-loading>
    </div>
  </main>
</template>

<script>
import newsCard from './components/NewsCard.vue';
import { mapActions, mapState, mapGetters } from '@common/store/modules/board';
import * as boardTypes from '@common/store/modules/board/types';
import * as commonActions from '@common/store/modules/common/types';
import { mapActions as commonMapActions } from '@common/store/modules/common';

import InfiniteLoading from 'vue-infinite-loading';

export default {
  components: {
    newsCard,
    InfiniteLoading,
  },
  data() {
    return {
      newsType: '',
      fetchCompleted: false,
      direction: 'top',
      infiniteId: 0,
      list: [],
      size: 10,
      page: 1,
      boardId: this.$route.query.boardId,
    };
  },
  beforeDestroy() {
    this[commonActions.SET_CUSTOM_HEADER_TEXT](undefined);
  },
  async mounted() {
    this.infiniteId += 1; //리스트 가져오기.
    await this.setTitle();
  },
  computed: {
    ...mapGetters({
      articles: boardTypes.ARTICLE_LIST,
    }),
  },
  methods: {
    ...mapActions([boardTypes.FETCH_ARTICLE_LIST]),
    ...commonMapActions([commonActions.SET_CUSTOM_HEADER_TEXT]),
    async getList() {
      const params = {
        boardId: this.boardId,
        page: this.page,
        size: this.size,
      };
      await this[boardTypes.FETCH_ARTICLE_LIST](params);
      this.fetchCompleted = true;
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.getList();

        if (this.page == 1) {
          this.list = [];
        }
        if (this.articles.content.length) {
          this.list.push(...this.articles.content);
          if (this.page == 1) {
            setTimeout(() => {
              this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
              //window.scrollTo(0, 0);
            }, 10);
          }
          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    async setTitle() {
      let title = '';
      if (this.boardId === 'BLACKCOW') {
        title = '오늘부터 할인하는 휴대폰 📱';
      } else if (this.boardId === 'PERCE_NEWS') {
        title = '나에게 딱 맞는 IT잇템';
      } else if (this.boardId === 'GREAT_TIP') {
        title = '휴대폰 싸게 사는 꿀팁';
      }
      await this[commonActions.SET_CUSTOM_HEADER_TEXT](title);
    },
  },
};
</script>
